import { FC } from 'react'

import ButtonNew, { ButtonNewProps } from './ButtonNew'

const IconButton: FC<ButtonNewProps> = ({
    variant = 'primary',
    style = 'fill',
    size = 'lg',
    leadingIcon,
    trailingIcon,
    onClick,
    type = 'button',
    disabled = false,
    sx,
    href,
    target,
    className,
    loading,
    ...rest
}) => {
    return (
        <ButtonNew
            type={type}
            onClick={onClick}
            disabled={disabled}
            href={href}
            target={target}
            hideLabel={true}
            variant={variant}
            style={style}
            size={size}
            leadingIcon={leadingIcon}
            trailingIcon={trailingIcon}
            className={className}
            loading={loading}
            {...rest}
            sx={{
                width: size === 'sm' ? '32px' : '40px',
                height: size === 'sm' ? '32px' : '40px',
                borderRadius: '100%',
                svg: {
                    width: size === 'sm' ? '20px' : '24px',
                    height: size === 'sm' ? '20px' : '24px',
                },
                ...sx,
            }}
        />
    )
}

export default IconButton
